module.exports = __webpack_public_path__ + "static/media/box-desafio-chave.a6abcb64.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/desafios/box-desafio-chave.png
// module id = 1249
// module chunks = 0